module.exports = __webpack_public_path__ + "static/img/case7.aee393d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/case7.png
// module id = s8yQ
// module chunks = 1